// src/components/TestimonialSlider.js
import React from 'react';
import TestimonialCard from './TestimonialCard';
import './TestimonialCard.css';
import pic from '../assets/pappukrs.jpg'

const TestimonialSlider = ({ testimonials }) => {
  return (
    <div className="testimonial-container">
      <div className="testimonial-slider">
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            // image={testimonial.image}
            image={testimonial.image}
            name={testimonial.name}
            designation={testimonial.designation}
            review={testimonial.review}
          />
        ))}
        {/* Duplicate cards for smooth infinite scrolling */}
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={`${index}-duplicate`}
            image={testimonial.image}
            // image={pic}
            name={testimonial.name}
            designation={testimonial.designation}
            review={testimonial.review}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialSlider;
